<template>
    <v-hover v-slot="{ hover }">
        <div v-ripple class="d-flex justify-space-between align-center py-3 primary-font" :style="hover && !edit ? `color: #579FA75C; background-color: ${layout == 'portal' ? '#579FA71F' : 'var(--v-primary-opacity-12)'}; cursor: pointer;` : ''" @click="!edit ? redirect(salon) : null">
            <div class="d-flex pl-2">
                <v-img width="116" height="76" :src="salon.imgUrl"></v-img>
                <div class="pl-2">
                    <span class="font-weight-bold" style="color: var(--v-primary-base)" :style="$vuetify.breakpoint.mdAndUp ? '' : 'font-size: 16px'">{{salon.name}}</span><br>
                    <span class="font-weight-light" style="color: var(--v-primary-base)" :style="$vuetify.breakpoint.mdAndUp ? '' : 'font-size: 14px'">{{salon.address}}</span> <br>
                    <span class="font-weight-light">{{salon.distance}}</span>
                </div>
            </div>
            <div>
                <transition mode="out-in" name="fab-transition">
                    <v-btn
                        v-if="edit"
                        :class="$vuetify.breakpoint.mdAndUp ? 'mx-2' : ''"
                        elevation="0"
                        fab
                        small
                        :color="hover ? 'var(--v-primary-opacity-06)' : 'white'"
                        @click="togglePopup(salon)"
                    >
                        <v-icon color="primary">fxt-trash</v-icon>
                    </v-btn>
                </transition>
            </div>
        </div>
    </v-hover>
</template>

<script>
export default {
    data: () => ({
        showDialog: false,
    }),
    props: {
        salon: {
            type: Object,
            required: true,
            default: null,
        },
        edit: {
            required: false,
            default: false,
            type: Boolean
        },
        layout: {
            required: false,
            default: 'chain',
            type: String
        }
    },
    methods: {
        redirect(salon) {
            this.layout == 'portal' ? window.open(`${process.env.VUE_APP_FIXIT_NO_URL}/frisor/${salon.urlFrendlyLink}/${salon.siteId}`, '_self') : this.$router.replace(`/about/${salon.urlFrendlyLink}`)
        },
        togglePopup(salon) {
            this.$emit('setSalon', salon)
            this.$emit('delete-salon', salon.siteId)
        }
    },
    computed: {

    }
}
</script>